export const PORTAL_TITLE = "Capital One Travel Portal";
export const VIEW_HOTEL_TITLE = "View Hotel";
export const CHOOSE_DATES = "Choose dates to see room rates";
